// Company information configuration
// DTE v2.0 multi-company: empresaId is REQUIRED in every DTE request body.
// It is injected automatically by the `invoiceApi` helper for DTE endpoints.
export const companyInfo = {
  empresaId: Number(process.env.REACT_APP_INVOICE_EMPRESA_ID) || 1,
  name: process.env.REACT_APP_INVOICE_COMPANY_NAME || "AAKTEI MANAGEMENT SpA",
  rut: process.env.REACT_APP_INVOICE_COMPANY_RUT || "78181331-1",
  businessActivity:
    "VENTA AL POR MAYOR DE HUEVOS, LACTEOS, ABARROTES Y DE OTROS ALIMENTOS",
  phone: "999999999",
  email: "admin@aaktei.com",
  acteco: 620100,
  address: {
    street: "Av. Siempre Viva 123",
    commune: "Santiago",
    city: "Santiago",
  },
  billing: {
    address: "Esmeralda 641, La Union",
  },
  defaultValues: {
    customerAddress: "AV APOQUINDO 4700 PISO 11",
    phone: "2",
    taxRate: 0.19, // 19%
  },
};

export const defaultBusinessActivity = "Administración pública";
